module.exports = __webpack_public_path__ + "static/media/musical_heavenly_choir_001_clipped.d732fad9.wav";